import cloneDeep from 'lodash.clonedeep';
import { select, put } from 'redux-saga/effects';

import {
  PinCamerasAction,
  UnpinCamerasAction,
  PIN_CAMERAS,
  updateScribe,
  PIN_ACTIVE_CAMERAS,
  PinActiveCamerasAction,
  UnpinActiveCamerasAction,
  pinCameras,
  unpinCameras,
  TogglePinsAction
} from 'js/actionCreators/scribeActions';
import { allCamerasPinned } from 'js/shared/allCamerasPinned';

import { getActiveElements, getScribeById } from '../selectors';

export function* updateCamerasPinned({ type, elementIds, scribeId }: PinCamerasAction | UnpinCamerasAction) {
  const cameraPinFlag = type === PIN_CAMERAS;
  const elementsToUpdate = Array.isArray(elementIds) ? elementIds : [elementIds];

  const scribe = (yield select(state => getScribeById(state, scribeId))) as ReturnType<typeof getScribeById>;

  if (scribe) {
    const scribeClone = cloneDeep(scribe);
    scribeClone.elements.forEach(el => {
      if (elementsToUpdate.includes(el.id) && el.type === 'Camera') {
        el.cameraPinned = cameraPinFlag;
      }
    });

    yield put(updateScribe(scribeClone));
  }
}

export function* updateCamerasPinnedOnActiveElements({
  type,
  scribeId,
  eventTrigger
}: PinActiveCamerasAction | UnpinActiveCamerasAction) {
  const actionCreator = type === PIN_ACTIVE_CAMERAS ? pinCameras : unpinCameras;
  const activeElements = (yield select(getActiveElements)) as ReturnType<typeof getActiveElements>;
  yield put(actionCreator(activeElements, scribeId, eventTrigger));
}

export function* toggleActiveSceneCameraPins({ scribeId }: TogglePinsAction) {
  const scribe = (yield select(state => getScribeById(state, scribeId))) as ReturnType<typeof getScribeById>;

  if (scribe) {
    const scribeClone = cloneDeep(scribe);
    const scribeElements = scribeClone.elements;
    const allCameras = scribeElements.filter(element => element.type === 'Camera');

    const activeSceneCamerasPinned = allCamerasPinned(scribeClone);

    allCameras.forEach(el => {
      el.cameraPinned = !activeSceneCamerasPinned;
    });
    yield put(updateScribe(scribeClone, true));
  }
}
